import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import classnames from 'classnames';

const LoadingBase = ({
  flexible = false,
  message = 'Loading',
  displayIcon = true,
  className = '',
}) => (
  <div
    className={classnames(
      'loading--wrapper',
      flexible && 'flexible',
      className
    )}
  >
    <div className="loading--content">
      {displayIcon && <Icon loading={true} size="huge" name="spinner" />}
      <div className="loading--message">{message}</div>
    </div>
  </div>
);

LoadingBase.propTypes = {
  message: PropTypes.string,
  displayIcon: PropTypes.bool,
  flexible: PropTypes.bool,
};

export { LoadingBase };



// WEBPACK FOOTER //
// ./src/components/loading/LoadingBase.js